import { AppButton, AppTextField } from 'components';
import { useEffect, useState } from 'react';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import ESTDropDown from 'components/molecules/ESTDropDown';
import StatusDropDown from 'components/molecules/StatusDropDown';
import AppImagePicker from 'components/ImagePicker';
import useStatus from 'hooks/useStatus';

function ManageES({ save, selectedItem = {}, handleSelectedItem, isPageMode = false }) {
  const [esName, handleESName] = useState('');
  const [EST, handleEST] = useState('');
  const [esKey, handleESKey] = useState('');
  const [status, handleStatus] = useStatus();
  const [imageData, handleImageData] = useState(null);
  const [disableSubmit, handleDisabling] = useState(false);
  const [formErrors, setFormErrors] = useState([]);

  useEffect(() => {
    if (selectedItem?._id) {
      handleESName(selectedItem?.name ?? '');
      handleESKey(selectedItem?.key ?? '');
      if (selectedItem?.status) handleStatus(selectedItem?.status);
      handleEST(selectedItem?.est?._id ?? '');
      handleImageData({ imageUrl: selectedItem?.logoFullUrl, logoUrl: selectedItem?.logoUrl });
    }
  }, [handleStatus, selectedItem]);

  function handleSave() {
    if (disableSubmit) return;

    setFormErrors([]);

    const data = {
      name: `${esName}`.trim(),
      key: `${esKey}`.trim(),
      estId: EST,
      status,
      logoUrl: imageData?.logoUrl,
      logoURL: imageData?.logoUrl,
    };

    const validation = manageESSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    save?.({ ...data, id: selectedItem?._id });

    clearData();
  }

  function clearData() {
    setFormErrors([]);

    handleESName('');
    handleESKey('');
    handleEST('');
    handleStatus('active');
    handleImageData(null);
    handleSelectedItem({});
  }

  const errors = checkForErrors(formErrors);

  return (
    <>
      {!isPageMode && (
        <div className="row">
          <div className="col-6">
            <h2 className="prime-head p-0 boldtitle">Manage Syllabus</h2>
            {selectedItem?._id ? <span>Update syllabus</span> : <span>Create a syllabus</span>}
          </div>
          <div className="col-6 prime-head text-right"></div>
        </div>
      )}

      {isPageMode && (
        <div className="row">
          <div className="col-12">
            <h2 className="prime-head p-0 boldtitle">
              {selectedItem?._id ? 'Update Syllabus' : 'Add Syllabus'}
            </h2>
          </div>
        </div>
      )}

      <div className="row mt-4">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="col-lg-12 col-md-6 col-sm-12">
            <AppTextField
              labelProps={{
                label: 'Syllabus name *',
                htmlFor: 'esName',
              }}
              inputProps={{
                placeholder: 'Syllabus name *',
                id: 'esName',
                name: 'esName',
                value: esName,
                onChange: (event) => handleESName(event.target.value),
              }}
              fieldErrors={errors['name']}
            />
          </div>
          <div className="col-lg-12 col-md-6 col-sm-12 mt-4">
            <StatusDropDown
              value={status}
              handleChange={(event) => handleStatus(event.target.value)}
            />
          </div>
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="col-lg-12 col-md-6 col-sm-12">
            <ESTDropDown
              enableAPI
              value={EST}
              handleChange={(event) => handleEST(event.target.value)}
              fieldErrors={errors['estId']}
            />
          </div>
          <div className="col-lg-12 col-md-6 col-sm-12 mt-4">
            <AppTextField
              labelProps={{
                label: 'Syllabus unique key',
                htmlFor: 'esKey',
              }}
              inputProps={{
                placeholder: 'Syllabus unique key',
                id: 'esKey',
                name: 'esKey',
                value: esKey,
                onChange: (event) => handleESKey(event.target.value),
              }}
            />
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12 disinline imgupload">
          <AppImagePicker
            image={imageData?.imageUrl}
            handleChange={(imageData) => handleImageData(imageData)}
            handleDisabling={(doDisable) => handleDisabling(doDisable)}
          />
        </div>
      </div>

      <div className="d-flex flex-row mt-4 justify-content-end">
        <div className="aligncenter savecancelbtnsec">
          <AppButton
            variantClass="btn-primary mx-3"
            style={{ minWidth: '1.5rem' }}
            onClick={handleSave}
          >
            {selectedItem?._id ? 'Update Syllabus' : 'Save Syllabus'}
          </AppButton>
          {!isPageMode && (
            <AppButton variantClass="btn-plane p--tint mx-3" onClick={clearData}>
              Cancel
            </AppButton>
          )}
        </div>
      </div>
    </>
  );
}

const manageESSchema = Joi.object({
  name: Joi.string().required().trim(),
  estId: Joi.string().required().trim(),
  status: Joi.string().required(),
});

ManageES.defaultProps = {
  save: () => {},
  handleSelectedItem: () => {},
};

export default ManageES;
